import { HTMLAttributes } from 'react';
import { cn } from 'shared/utils/cn';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-2xl border border-border/40 bg-surface p-6 shadow-card transition-shadow duration-300 hover:shadow-card-hover', className)}
      {...props}
    />
  );
}
